import React from "react";
import "~/css/reception/ReceptionButton.css";

type Props = {
  name: string;
  onClick: () => void;
};

/**
 * 会社名の選択ボタン（会社一覧の 1 要素）。
 *
 * @param props.name ボタンに表示する会社名
 * @param props.onClick 会社選択時に呼び出されるクリックハンドラー
 */
const CompanyListCell: React.FC<Props> = ({ name, onClick }) => {
  return (
    <button type="button" className="company-cell reception-button--large" onClick={onClick}>
      <span className="company-cell__name">{name}</span>
    </button>
  );
};

export default CompanyListCell;
